import script from "./OfNavBarLeft.vue?vue&type=script&setup=true&lang=js"
export * from "./OfNavBarLeft.vue?vue&type=script&setup=true&lang=js"

import "./OfNavBarLeft.vue?vue&type=style&index=0&id=29150bc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29150bc2"]])

export default __exports__